
import { defineComponent } from "vue";

import FormLogin from "@/components/organisms/form/login/index.vue";

export default defineComponent({
  components: { FormLogin },
  props: {
    formData: {
      type: Object,
      default: () => ({
        username: "",
        password: "",
      }),
    },
    error: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["submit"],
});
